module.exports = __webpack_public_path__ + "img/arrow-down.feef03d6.svg";